export const environment = {
  production: false,
  GOOGLE_MAPS_API_KEY: 'AIzaSyBi6HjfL7y-rVK762BS-xYPl5Kn57jHfGE'
};